<template>
  <div class="article-frame">
    <div class="article-box">
      <img class="header-img" :src="$getThemeImagePath('useful_link/pc_banner_support.png')">
      <div class="content pos-relative">
        <go-to-top />
        <div class="support-select-frame">
          <a class="sup-items" @click="$router.push('/page/sup-how-to-register')">
            <img class="sup-items-img" :src="$getThemeImagePath('useful_link/icon_login_method.png')" alt="">
            <p class="txt">
              登録方法
            </p>
          </a>
          <a class="sup-items" @click="$router.push('/page/sup-how-to-login')">
            <img class="sup-items-img" :src="$getThemeImagePath('useful_link/icon_login.png')" alt="">
            <p class="txt">
              ログイン
            </p>
          </a>
          <a class="sup-items" @click="$router.push('/page/sup-payment-method')">
            <img class="sup-items-img" :src="$getThemeImagePath('useful_link/icon_deposit_withdraw.png')" alt="">
            <p class="txt">
              ご入出金
            </p>
          </a>
          <a class="sup-items" @click="$router.push('/page/sup-account-binding')">
            <img class="sup-items-img" :src="$getThemeImagePath('useful_link/icon_account_binding.png')" alt="">
            <p class="txt">
              出金アカウント<br>の紐づけ方法
            </p>
          </a>
          <a class="sup-items" @click="$router.push('/page/sup-wallet')">
            <img class="sup-items-img" :src="$getThemeImagePath('useful_link/icon_wallet.png')" alt="">
            <p class="txt">
              ウォレット
            </p>
          </a>
          <a class="sup-items" @click="$router.push('/page/sup-event-bonus')">
            <img class="sup-items-img" :src="$getThemeImagePath('useful_link/icon_event_bonus.png')" alt="">
            <p class="txt">
              キャンペーン
            </p>
          </a>
          <a class="sup-items" @click="$router.push('/page/sup-verify-your-account')">
            <img class="sup-items-img" :src="$getThemeImagePath('useful_link/icon_confirm_method.png')" alt="">
            <p class="txt">
              本人確認方法
            </p>
          </a>
          <a class="sup-items" @click="$router.push('/page/sup-about-shop')">
            <img class="sup-items-img" :src="$getThemeImagePath('useful_link/icon_shop.png')" alt="">
            <p class="txt">
              ショップ
            </p>
          </a>
          <a class="sup-items" @click="$router.push('/page/sup-coupon')">
            <img class="sup-items-img" :src="$getThemeImagePath('useful_link/icon_coupon.png')" alt="">
            <p class="txt">
              クーポン
            </p>
          </a>
          <a class="sup-items" @click="$router.push('/page/sup-vip-class-upgrading')">
            <img class="sup-items-img" :src="$getThemeImagePath('useful_link/icon_vip_class_upgrading.png')" alt="">
            <p class="txt">
              VIPに<br>アップグレード
            </p>
          </a>
          <a class="sup-items" @click="$router.push('/page/sup-faq')">
            <img class="sup-items-img" :src="$getThemeImagePath('useful_link/icon_FAQ.png')" alt="">
            <p class="txt">
              よくある 質問
            </p>
          </a>
          <a class="sup-items" @click="$router.push('/page/sup-self-restraint')">
            <img class="sup-items-img" :src="$getThemeImagePath('useful_link/icon_self_restriction.png')" alt="">
            <p class="txt">
              自己制限
            </p>
          </a>
        </div>
      </div>
      <!-- content End -->
    </div>
    <!-- article-box End -->
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'

export default {
  name: 'Support',
  components: {
    goToTop
  },
  data() {
    return {

    }
  },
  computed: {

  },
  created() {

  },
  methods: {

  }
}
</script>
